<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.go(-1)"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>医生详情</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="doctor">
      <!--头像-->
      <div class="img">
        <template v-if="doctorInfo.ygxm">
          <img
            v-if="doctorInfo.headerImg"
            :src="doctorInfo.headerImg"
            @error="onImgError()"
            alt=""
          />
          <img v-else src="@/assets/img/doc.png" alt="" />
        </template>
        <img v-else src="@/assets/img/ptmz.png" alt="" />
      </div>

      <!--头像-->

      <div class="list-pro-name">
        <div class="item-name">
          <span class="item-name-text">{{ doctorInfo.ygxm || "普通门诊" }}</span>
          <span class="item-name-job">{{ doctorInfo.ygzc }}</span>
        </div>
        <div class="item-department-name">
          {{ doctorInfo.ghksmc }}
        </div>
        <div class="about" v-if="doctorInfo.goodAt">
          <PanelTitle title="擅长"></PanelTitle>
          <p>
            {{ doctorInfo.goodAt }}
          </p>
        </div>
        <div class="about" v-if="doctorInfo.introduce">
          <PanelTitle title="简介"></PanelTitle>
          <p>
            {{ doctorInfo.introduce }}
          </p>
        </div>
      </div>
    </div>
    <div class="appointment-time">
      <PanelTitle :title="`${this.doctorInfo.yqmc}`" class="title-ment"></PanelTitle>

      <div v-if="scheduleList.length > 0">
        <div v-for="(item, i) in scheduleList" :key="i">
          <a-card hoverable>
            <div class="week">
              <div class="week-now">{{ item.zblb | dutyTypeFilter }}</div>
              <div class="week-now-time">
                <div class="item">
                  <span class="item-time"
                    >{{ item.gzrq }} {{ item.gzrq | showWeekFilter }}</span
                  >
                  <span class="item-price">
                    <span>{{ item.ygxm ? "专家" : "普通" }}</span>
                    <span class="fontColor1">挂号费用：{{ item.ghf }}元</span>
                  </span>
                  <span class="item-btn">
                    <a-button disabled v-if="item.tgbz == 1">停诊</a-button>
                    <a-button
                      type="primary"
                      :disabled="parseInt(item.hyzs) <= 0"
                      v-else
                      @click="showModal(item)"
                      >{{
                        parseInt(item.hyzs) > 0 ? "余 " + item.hyzs : "已满"
                      }}</a-button
                    >
                  </span>
                </div>
              </div>
            </div>
          </a-card>
          <div class="line"></div>
        </div>
      </div>
      <div v-else>
        <a-empty description="暂无排号" />
      </div>
    </div>

    <!--号源-->
    <a-modal
      wrapClassName="modalstyle"
      v-model="visible"
      :title="modalTitle"
      :footer="null"
      width="50%"
    >
      <section v-if="sourceList && sourceList.length > 0" class="source-span">
        <span class="item-btn-time" v-for="(item, index) in sourceList" :key="index">
          <span class="time">{{ item.sourceSeria }}号</span>
          <span class="time"> {{ item.sourceTime }}</span>
          <a-button type="primary" @click="doConfirmation(item)">预约 </a-button>
        </span>
      </section>
      <a-empty v-else description="暂无排号" class="auto-m" />
    </a-modal>
  </div>
</template>

<script>
import PanelTitle from "@/components/panel-title";
import { queryResourceInfo, querySourceInfo } from "@/api/registration";
import base from "@/assets/base/base.js";
export default {
  components: {
    PanelTitle,
  },
  data() {
    return {
      modalTitle: "",
      loading: false,
      visible: false,
      visible1: false,
      dutyType: "",
      doctorInfo: {},
      scheduleList: [],
      sourceList: [],
    };
  },
  watch: {
    "$route.query": {
      handler(val) {
        const data = JSON.parse(val.data);
        this.doctorInfo = data;
        this.dateList = base.getSevenYMD(new Date());
        this.getData();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    onImgError() {
      this.$set(this.doctorInfo, "headerImg", require("@/assets/img/doc.png"));
    },
    //获取排班情况
    async getData() {
      const params = {
        ygdm: this.doctorInfo.ysdm, //医生编号
        mzks: this.doctorInfo.ghks, //科室编号
        qssj: this.dateList[0], //起始时间
        jssj: this.dateList[this.dateList.length - 1], //结束时间
      };
      const { code, data } = await queryResourceInfo(params);
      if (code == 200) {
        this.scheduleList = data;
      }
    },
    //确认预约
    doConfirmation(item) {
      const params = {
        dutyType: this.dutyType,
        ...this.doctorInfo,
        ...item,
        expense: this.doctorInfo.ghf,
      };
      this.$router.push({
        path: "/confirmation",
        query: {
          data: JSON.stringify(params),
        },
      });
    },

    //获取号源信息
    async showModal(item) {
      //停诊 tgbz 0正常 1停挂
      if (item.tgbz == "1") {
        this.$message.warning("已停诊，请选择其他时间");
        return;
      }

      //已满
      if (parseInt(item.hyzs) <= 0 || !item.hyzs) {
        this.$message.warning("号源已满，请选择其他时间");
        return;
      }

      this.doctorInfo = {
        ...this.doctorInfo,
        ...item,
      };
      console.log(this.doctorInfo);
      this.dutyType = item.zblb;

      this.modalTitle = `${item.gzrq} ${item.zblb == 1 ? "上午" : "下午"}`;

      this.visible = true;

      const params = {
        date: item.gzrq,
        doctorId: this.doctorInfo.ysdm,
        dutyType: item.zblb,
        officeId: this.doctorInfo.ghks,
        organizationId: "1001",
      };
      const { code, data } = await querySourceInfo(params);
      if (code == 200) {
        this.sourceList = data;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.auto-m {
  margin: auto;
}
.auto-p {
  margin: auto;
  position: relative;
  left: 55%;
}

.line {
  height: 4px;
}

.week {
  display: flex;
  position: relative;
  width: 100%;

  .week-now {
    width: 50px;
    background-color: #f6f6f6;
    font-size: 16px;
    color: #3f86ff;
    padding: 0 5px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .week-now-time {
    // width: 873px;
    flex: 1;
    .item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 12px 32px;

      > span {
        font-size: 14px;
      }
      .item-time {
        font-weight: bold;
      }
      .item-price {
        flex: 1;
        padding: 0 20px;
        box-sizing: border-box;
        span {
          margin-right: 20px;
        }
      }
    }
  }
}

.fontColor1 {
  color: #fe695c;
  font-size: 14px;
  padding: 0 5px;
}

.fontColor {
  color: #3f86ff;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.container {
  .doctor {
    margin-top: 20px;
    box-sizing: border-box;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 30px;
    cursor: pointer;
    .img {
      width: 60px;
      height: 60px;
      margin-right: 12px;
      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }

    .list-pro-name {
      flex: 1;
      .item-name {
        margin: 2px 0;
      }

      .item-name {
        font-size: 14px;

        &-text {
          font-size: 20px;
          color: #333;
        }

        &-job {
          color: #333;
          padding: 0 10px;
        }
      }

      .item-department-name {
        margin-top: 4px;
        color: #666;
      }

      .about,
      .skilled {
        margin-top: 20px;

        p {
          color: #8e8e8e;
          padding-left: 6px;
        }
      }
    }
  }

  .appointment-time {
    padding-left: 8px;

    .title-ment {
      margin: 20px 0;
    }
  }
}

/deep/ .modalstyle {
  .ant-modal-body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 600px;
    overflow-y: auto;

    .source-span {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
    }

    > span {
      width: 45%;
    }

    .item-btn-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 12px;
      // width: 210px;
      // box-sizing: border-box;
      border-bottom: 1px solid #faf7fa;

      .time {
        font-size: 14px;
        margin-right: 10px;
        width: 80px;
      }
      .time:first-child {
        width: 40px;
      }
    }
  }
}
/deep/ .modalstyle1 {
  .ant-modal-body {
    display: flex;
    justify-content: center;
  }
}
</style>
